import React, { useState, useCallback, useMemo, useEffect } from 'react';
import { Form, Input, Row, Col, Button, Modal } from 'antd';
import {
  DeleteOutlined,
  UpCircleOutlined,
  DownCircleOutlined,
  EditOutlined,
} from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { CustomCollapseCard, CustomForm, CustomFormItem, Text, useText } from '@src/components';
import AddCarSelectInformation from './AddCarSelectInformation';
import AddDriverSelectInformation from './AddDriverSelectInformation';
import AddCarSetLimitType from './AddCarSetLimitType';
import trashImage from '@src/assets/icons/btn-sil.svg';
import {
  setActiveStep,
  incrementActiveStep,
} from '@src/store/slice/addNewCarStore/addCarTypeSlice';
import {
  resetCurrentLoadAddCarPlateInformation,
  setAllPlatesArray,
} from '@src/store/slice/addNewCarStore/addCarPlateInformationSlice';
import {
  resetCurrentLoadAddCarPlateDetail,
  setAllPlatesDetailItems,
} from '@src/store/slice/addNewCarStore/addCarPlateDetailSlice';
import { DeviceType } from '@src/store/enums';
import '@src/styles/addNewCar/addCarPlateDetail.scss';
import { useMediaQuery } from '@src/hooks/useMediaQuery';
import CustomImage from '@src/components/CustomImage';

const AddCarPlateDetail = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const isMobil = useMediaQuery({ query: '(max-width: 768px)' });
  const { allPlatesArray, allPlatesDetails } = useSelector(
    (state) => state?.addCarPlateInformation,
  );
  const { selectCustomerVousList, selectVehicleDeviceTypeList } = useSelector(
    (state) => state?.addCarType,
  );
  const [plateFields, setPlateFields] = useState(allPlatesArray);
  const [errors, setErrors] = useState({});
  const [expandedPlates, setExpandedPlates] = useState({});
  const [vehicleDetailsState, setVehicleDetailsState] = useState({});
  const [copyDetailsChecked, setCopyDetailsChecked] = useState({});
  const [limitDetailsState, setLimitDetailsState] = useState({});
  const [driveDetailsState, setDriveDetailsState] = useState({});
  const [copyLimitDetailsChecked, setCopyLimitDetailsChecked] = useState({});
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [openExpandLimitDetails, setOpenExpandLimitDetails] = useState(false);

  const edit2 = useText('edit2');
  const areYouSureYouWantToGoBack = useText('areYouSureYouWantToGoBack');

  useEffect(() => {
    if (plateFields?.length > 0 && allPlatesDetails?.length === 0) {
      handleToggleExpand(plateFields[0].name);
    }
  }, [plateFields]);

  useEffect(() => {
    try {
      if (allPlatesDetails && allPlatesArray) {
        let openExpandLimitDetailsArr = [];
        allPlatesDetails?.map((item, index) => {
          let obj = {};
          if (item?.vehicleType) {
            obj.vehicleType = {
              id: parseInt(item.vehicleType?.split(' ')[0], 10),
              name: item.vehicleType?.split(' ')[2],
            };
            obj.vehicleTypeId = parseInt(item.vehicleType?.split(' ')[0], 10);
          }
          if (item?.segment) {
            obj.vehicleFuelType = {
              id: parseInt(item.segment?.split(' ')[0], 10),
              name: item.segment?.split(' ')[2],
            };
            obj.fuelTypeId = parseInt(item.segment?.split(' ')[0], 10);
          }
          if (item?.vehicleUsageType) {
            obj.attribute = {
              id: parseInt(item.vehicleUsageType?.split(' ')[0], 10),
              name: item.vehicleUsageType?.split(' ')[2],
            };
            obj.attributeNameId = parseInt(item.vehicleUsageType?.split(' ')[0], 10);
          }
          if (item?.deliveryAddress) {
            obj.address = {
              id: parseInt(item.deliveryAddress?.split(' ')[0], 10),
              name: item.deliveryAddress?.split(' ')[2],
            };
            obj.addressGetListId = parseInt(item.deliveryAddress?.split(' ')[0], 10);
          }
          if (item?.department) {
            obj.department = {
              id: parseInt(item.department?.split(' ')[0], 10),
              name: item.department?.split(' ')[2],
            };
            obj.departmanId = parseInt(item.department?.split(' ')[0], 10);
          }
          if (item?.costCenter) {
            obj.costCenter = {
              id: parseInt(item.costCenter?.split(' ')[0], 10),
              name: item.costCenter?.split(' ')[2],
            };
            obj.costCenterId = parseInt(item.costCenter?.split(' ')[0], 10);
          }
          setVehicleDetails(index, obj, allPlatesArray[index].name);
          handleUpdatePlateDetails(allPlatesArray[index], 'vehicleDetails', obj);
          let limitObj = {};
          if (item?.limitType) {
            limitObj.limitType = {
              id: parseInt(item.limitType?.split(' ')[0], 10),
              name: item.limitType?.split(' ')[2],
            };
            limitObj.limitTypeId = parseInt(item.limitType?.split(' ')[0], 10);
          }
          if (item?.limitValueType) {
            limitObj.limitValueType = {
              id: parseInt(item.limitValueType?.split(' ')[0], 10),
              name: item.limitValueType?.split(' ')[2],
            };
            limitObj.limitValueTypeId = parseInt(item.limitValueType?.split(' ')[0], 10);
          }
          if (item?.priceStr) {
            limitObj.limitValue = parseInt(item.priceStr, 10);
          }
          setLimitDetails(index, limitObj, allPlatesArray[index].name);
          handleUpdatePlateDetails(allPlatesArray[index], 'limitDetails', limitObj);
          if (limitObj.limitType) {
            openExpandLimitDetailsArr.push(true);
          } else {
            openExpandLimitDetailsArr.push(false);
          }
          let driverObj = {
            name: allPlatesArray[index].name,
          };
          if (item?.driverName) {
            driverObj.driverName = item.driverName;
          }
          if (item?.driverGsm) {
            try {
              const formatPhoneNumber = (phone) => {
                let formattedPhone = phone.replace(/[^\d]/g, '');
                if (formattedPhone.startsWith('90')) {
                  formattedPhone = formattedPhone.slice(2);
                }
                return formattedPhone;
              };
              driverObj.driverPhone = formatPhoneNumber(item.driverGsm);
            } catch (error) {
              console.error(error);
              driverObj.driverPhone = item.driverGsm;
            }
          }
          if (item?.driverEmail) {
            driverObj.driverEmail = item.driverEmail;
          }
          setDriveDetails(index, driverObj, allPlatesArray[index].name);
          handleUpdatePlateDetails(allPlatesArray[index], 'driverDetails', driverObj);
        });
        setOpenExpandLimitDetails(openExpandLimitDetailsArr);
      }
    } catch (error) {
      console.error(error);
    }
  }, [allPlatesDetails, allPlatesArray]);

  const showDeleteConfirm = (plateName) => {
    if (plateFields.length === 1) {
      setIsModalVisible(true);
    } else {
      handleRemovePlate(plateName);
    }
  };

  const handleModalOk = () => {
    dispatch(setActiveStep(1));
    dispatch(resetCurrentLoadAddCarPlateInformation());
    dispatch(resetCurrentLoadAddCarPlateDetail());
    setIsModalVisible(false);
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
  };

  const handleRemovePlate = (name) => {
    const updatedPlateFields = plateFields.filter((field) => field.name !== name);

    form.resetFields([name]);
    setErrors({ ...errors, [name]: null });

    const removedPlate = plateFields.find((field) => field.name === name);
    if (removedPlate) {
      dispatch(setAllPlatesDetailItems({ type: 'REMOVE', id: removedPlate.id }));
    }
    dispatch(setAllPlatesArray(updatedPlateFields));

    setPlateFields(updatedPlateFields);
  };

  const handleToggleExpand = (name) => {
    setExpandedPlates({
      ...expandedPlates,
      [name]: !expandedPlates[name],
    });
  };

  const setVehicleDetails = (index, details, name) => {
    setVehicleDetailsState((prevDetails) => ({
      ...prevDetails,
      [index]: { ...details, name },
    }));
  };

  const setLimitDetails = (index, details, name) => {
    setLimitDetailsState((prevDetails) => ({
      ...prevDetails,
      [index]: { ...details, name },
    }));
  };

  const setDriveDetails = (index, details, name) => {
    setDriveDetailsState((prevDetails) => ({
      ...prevDetails,
      [index]: { ...details, name },
    }));
  };

  const allFieldsPresent = useMemo(() => {
    if (plateFields.length === 0) {
      return false;
    }

    return plateFields.every((field) => {
      const vehicleDetails = Object.values(vehicleDetailsState).find(
        (details) => details.name === field.name,
      );
      const limitDetails = Object.values(limitDetailsState).find(
        (details) => details.name === field.name,
      );
      const driverDetails = Object.values(driveDetailsState).find(
        (details) => details.name === field.name,
      );

      const basicFieldsValid =
        vehicleDetails?.vehicleTypeId &&
        vehicleDetails?.attributeNameId &&
        vehicleDetails?.fuelTypeId &&
        vehicleDetails?.addressGetListId;

      const basicPOMobileFieldsValid =
        vehicleDetails?.vehicleTypeId &&
        vehicleDetails?.attributeNameId &&
        vehicleDetails?.fuelTypeId;

      // Eğer limitDetails mevcutsa ve limitTypeId girildiyse, limitTypeId ve limitValue seçilmiş olmalı
      const limitFieldsValid =
        !limitDetails?.limitTypeId || (limitDetails?.limitTypeId && limitDetails?.limitValue);

      if (selectVehicleDeviceTypeList?.deviceTypeId === DeviceType.TYPE_10) {
        const driverDetailsValid =
          driverDetails?.driverPhone?.length >= 10 &&
          (driverDetails?.sendDriverCode || driverDetails?.sendOrderCode);
        return basicFieldsValid && driverDetailsValid && limitFieldsValid;
      }

      if (selectVehicleDeviceTypeList?.deviceTypeId === DeviceType.TYPE_2) {
        const driverDetailsValid = driverDetails?.sendDriverCode
          ? driverDetails?.driverPhone?.length >= 10
          : true;
        return basicPOMobileFieldsValid && driverDetailsValid && limitFieldsValid;
      }

      if (selectVehicleDeviceTypeList?.deviceTypeId === DeviceType.TYPE_17) {
        return (
          basicPOMobileFieldsValid && limitFieldsValid && driverDetails?.driverPhone?.length >= 10
        );
      }

      if (selectVehicleDeviceTypeList?.deviceTypeId === DeviceType.TYPE_18) {
        return basicPOMobileFieldsValid;
      }

      return basicFieldsValid && limitFieldsValid;
    });
  }, [
    plateFields,
    vehicleDetailsState,
    limitDetailsState,
    driveDetailsState,
    selectVehicleDeviceTypeList,
  ]);

  const handleCarApproval = useCallback(async () => {
    console.log('step 3');
    dispatch(incrementActiveStep());
  }, [dispatch]);

  const handleUpdatePlateDetails = (field, key, details) => {
    const id = field.id;
    const plateNumber = field.plate;

    console.log(`Updating ${key} with details:`, details);

    dispatch(
      setAllPlatesDetailItems({
        id: id,
        plateNumber: plateNumber,
        selectCustomerVousList: selectCustomerVousList,
        selectVehicleDeviceTypeList: selectVehicleDeviceTypeList,
        [key]: details,
      }),
    );
  };

  return (
    <>
      <div className="add-car-plate-detail-content" data-testid="add-car-plate-detail-component">
        <Row justify={'center'} className="header-row-title" style={{ marginBottom: '8px' }}>
          <span>
            <Text t="licensePlateDetails" />
          </span>
        </Row>
      </div>
      {plateFields.map((field, index) => (
        <div
          key={field.id}
          className="add-car-plate-detail-content"
          data-testid="add-car-plate-detail-component"
          style={{ marginBottom: '-12px' }}
        >
          <CustomCollapseCard
            className={`${expandedPlates[field.name] ? 'expand-border-content' : ''}`}
          >
            <div className="monthly-order-container">
              <CustomForm
                name="monthlyOrderForm"
                className="monthly-order-form"
                initialValues={{}}
                autoComplete="off"
                layout={'horizontal'}
                form={form}
              >
                <div className="monthly-amount-content">
                  <Row gap="middle" justify="space-between">
                    <div className="form-item">
                      <Col align="middle" justify="space-between">
                        <CustomFormItem
                          label={
                            isMobil ? (
                              ''
                            ) : (
                              <>
                                <Text t="plate" /> {field.id}
                              </>
                            )
                          }
                          name={field.name}
                          className="monthly-amount-form-item"
                        >
                          <Input
                            className={`box border-left custom-readonly-input ${
                              expandedPlates[field.name] ? 'expanded' : ''
                            }`}
                            defaultValue={field?.plate}
                            maxLength={10}
                            readOnly
                            disabled
                          />

                          <Button
                            style={{
                              borderWidth: 0,
                              backgroundColor: 'transparent',
                              color: 'transparent',
                              position: 'absolute',
                              width: 220,
                              height: 50,
                            }}
                            onClick={() => handleToggleExpand(field.name)}
                          >
                            {field?.plate}
                          </Button>
                        </CustomFormItem>
                      </Col>
                    </div>
                    <Col className="delete-button-col" align="flex-end" justify="space-between">
                      {plateFields.length > 0 &&
                        (allPlatesDetails?.length > 0 ? (
                          <>
                            <Button
                              type="text"
                              icon={<EditOutlined style={{ color: '#1d2228', fontSize: '16px' }} />}
                              onClick={() => handleToggleExpand(field.name)}
                              className="toggle-button"
                              style={{
                                borderRadius: 6,
                                marginRight: 6,
                              }}
                            >
                              <span style={{ color: '#1e293b' }}>{edit2}</span>
                            </Button>
                            <Button
                              type="text"
                              icon={<CustomImage src={trashImage} />}
                              onClick={() => showDeleteConfirm(field.name)}
                            />
                          </>
                        ) : (
                          <>
                            <Button
                              type="text"
                              icon={
                                <DeleteOutlined style={{ color: '#1d2228', fontSize: '24px' }} />
                              }
                              onClick={() => showDeleteConfirm(field.name)}
                            />
                            <Button
                              type="text"
                              icon={
                                expandedPlates[field.name] ? (
                                  <UpCircleOutlined
                                    style={{ color: '#1d2228', fontSize: '24px' }}
                                  />
                                ) : (
                                  <DownCircleOutlined
                                    style={{ color: '#1d2228', fontSize: '24px' }}
                                  />
                                )
                              }
                              onClick={() => handleToggleExpand(field.name)}
                              className="toggle-button"
                            />
                          </>
                        ))}
                    </Col>
                  </Row>
                </div>
              </CustomForm>
              {expandedPlates[field.name] && (
                <>
                  <AddCarSelectInformation
                    index={index}
                    vehicleDetails={vehicleDetailsState[index] || {}}
                    setVehicleDetails={(details) => {
                      setVehicleDetails(index, details, field.name);
                      handleUpdatePlateDetails(field, 'vehicleDetails', details);
                    }}
                    plateFields={plateFields}
                    setCopyDetailsChecked={setCopyDetailsChecked}
                    vehicleDetailsState={vehicleDetailsState}
                  />

                  <AddCarSetLimitType
                    index={index}
                    limitDetails={limitDetailsState[index] || {}}
                    setLimitDetails={(details) => {
                      setLimitDetails(index, details, field.name);
                      handleUpdatePlateDetails(field, 'limitDetails', details);
                    }}
                    plateFields={plateFields}
                    copyLimitDetailsChecked={copyLimitDetailsChecked}
                    setCopyLimitDetailsChecked={setCopyLimitDetailsChecked}
                    limitDetailsState={limitDetailsState}
                    openExpandLimitDetails={openExpandLimitDetails[index]}
                  />

                  <AddDriverSelectInformation
                    index={index}
                    driveDetails={driveDetailsState[index] || {}}
                    setDriverDetails={(details) => {
                      setDriveDetails(index, details, field.name);
                      handleUpdatePlateDetails(field, 'driverDetails', details);
                    }}
                  />
                </>
              )}
            </div>
          </CustomCollapseCard>
        </div>
      ))}
      <div className="step-btn-container" style={{ marginTop: '30px' }}>
        <Button
          id="add-new-car-container-next-btn"
          className="next-btn"
          disabled={!allFieldsPresent}
          onClick={handleCarApproval}
        >
          <Text t="continue" />
        </Button>
      </div>
      <Modal
        title={areYouSureYouWantToGoBack}
        visible={isModalVisible}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        okText={useText('yes')}
        cancelText={useText('no')}
        centered={true}
      >
        <p>
          <Text t="ifYouPerformThisTransactionYourCurrentInformation" />
        </p>
      </Modal>
    </>
  );
};

export default AddCarPlateDetail;
